import type { CensusField, CensusLineCheck } from "./hooks/useCensusValidation";

interface LineRules {
  line: string;
  fields: CensusField[];
}

/**
 * The fields each quoted line is checked for.
 *
 * Read off the checks the server returned rather than restated here: the
 * checklist is the server's to define, and a second copy would drift.
 */
export const checklistFieldsByLine = (
  lines: readonly CensusLineCheck[],
): LineRules[] =>
  lines.map((line) => ({
    line: line.line,
    fields: line.checks.map((check) => check.field),
  }));
